import { SplitDirection } from "@/store/modes/alignment-ui-types";
import {
  FaroTooltip,
  SplitscreenStartIcon,
  ToolButton,
  ToolGroup,
} from "@faro-lotv/flat-ui";
import { OverlayToolbar } from "@/components/ui/overlay-toolbar";
import type { JSX } from "react";

type ScreenSplitDirectionToggleProps = {
  /** screen split direction */
  splitDirection: SplitDirection;

  /** callback function when button is clicked */
  onClick(): void;
};

/**
 * @returns split screen toggle between vertical and horizontal split
 */
export function ScreenSplitDirectionToggle({
  splitDirection,
  onClick,
}: ScreenSplitDirectionToggleProps): JSX.Element {
  const tooltip =
    splitDirection === SplitDirection.verticalSplit
      ? "Split horizontally"
      : "Split vertically";

  return (
    <OverlayToolbar
      sx={{
        position: "absolute",
        right: 20,
        top: "55%",
        transform: "translate(0, -50%)",
      }}
    >
      <ToolGroup>
        <FaroTooltip title={tooltip}>
          <ToolButton
            value="splitscreen-direction"
            selected={false}
            onClick={onClick}
          >
            <SplitscreenStartIcon
              sx={{
                transform:
                  splitDirection === SplitDirection.horizontalSplit
                    ? "rotate(90deg)"
                    : "none",
              }}
            />
          </ToolButton>
        </FaroTooltip>
      </ToolGroup>
    </OverlayToolbar>
  );
}
